import _u from './utility';
import _v from './vars';
import _fn from './main-fn';

const makeCall = function() {
	document.dispatchEvent(new CustomEvent('beforePageView'));
	_fn.wmdSetContext('wb.plt', _fn.getLoadTime());	
	if (typeof _v.g['s_not_pageview'] === 'undefined' || _v.g['s_not_pageview'] === "n") {
		if (typeof s_md.contextData['wb.pagination'] !== 'undefined' && _v.g['s_pagenum'] !== s_md.contextData['wb.pagination']) {
			_v.g['s_pagenum'] = s_md.contextData['wb.pagination']; // Allow for override of 'wb.pagination' value on 'beforePageView' event - as used on D&D virtual pagination
		}
		_fn.wmdPageview('', _v.g['s_pagenum']);
	}
	else {
		_v['firstPvDone'] = true;
		window.firstPvDone = _v['firstPvDone'];
		document.dispatchEvent(new CustomEvent('afterPageView'));
	}
	_v.defaultPV = false;
}

export default makeCall;